import { useContext, useEffect, useReducer, useState } from "react"
import { Get, Post2 } from "../Rutas/ApiRest"
import { Carga, VendemosContigo, cuentaCliente } from "../Rutas/Servicios"
import { tokens } from "../Context/Tokens"
import { Mostrar } from "../Context/Mostrando"
import { ReferenciaDTO } from "../Model/ReferenciaDTO"
import { Contexto } from "../Context/Contexto"
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion"

export default function VendemosContigoSin()
{

    const {Cli}=useContext(Contexto)
    const [guias,setguias]=useState<any>("")
    const {tok}=useContext(tokens)
    const {Mostrardo}=useContext(Mostrar)
    const [seleccionGuias,SetseleccionGuias]=useState<any>([])
    const [seleccionRegion,SetseleccionRegion]=useState<any>("")
    const [state,dispatch]=useReducer(reducer,{envio:"",preparacion:"",Nombre:"", Direccion:"",telefono:"",Numero:"",Ciudad:""})
    const {SetLoading,SetMensajeEmergente,SetId2,Id2,SetId,Id}=useContext(MensajeContActualizacion)
    const [stateCaluladora,dispachCalculadora]=useReducer(reducerCalculadora,{Precio:0,valor:0,peso:0,idPeso:0,despacho:-1,comuna:"",mensaje:true})
    const [SelectComunaCalculadora,SetSelectComunaCalculadora]=useState<any[]>([])
    useEffect(()=>
    {
        traerGuias()
        
    },[])

    useEffect(()=>
    {
        
        traerGuias()
    },[Id2])

    function reducer(state:any,action:any)
  {
    switch(action.type)
    {
      case "cambio":return {
        ...state,[action.input.name]:action.input.value
      }
      case "Reinicio":return{envio:"",preparacion:"",Nombre:"", Direccion:"",telefono:""}
    }
   
    return state;
  }
  const SelectCalDespacho=(event:any)=>
    {
      SetSelectComunaCalculadora([])
      actualizarComunaPreferente(event.target.value)
      console.log(event.target)
    }
    function reducerCalculadora(state:any,action:any)
    {
      switch(action.type)
      {
        case "cambio":return {
          ...state,[action.input.name]:action.input.value
        }
      }
    
      return state;
    }

    const actualizarComunaPreferente=(id:number)=>
        {
            const datos=Get(Carga.SucursalesBusqueda.replace("@idRegion",id+"") ,"application/json",tok)
            datos?.then(resultado=>{
              resultado.map((e:any)=>
              {
                SetSelectComunaCalculadora((a:any)=>[...a,<option value={e.nombre}>{e.nombre}</option>])
              });
              dispachCalculadora({type:"cambio",input:{
                name:"comuna",
                value:resultado[0].nombre
              }})
            })
        }

    const cambioComunaCal=(event:any)=>
        {
          dispachCalculadora({type:"cambio",input:{
            name:"comuna",
            value:event.target.value
          }})
        }

       

    const traerGuias=()=>
    {
        dispatch({type:"Reinicio"})
        const consulta=Get(VendemosContigo.TraerGuiasSin.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode),'application/json',tok)
        consulta.then(resultado=>{setguias(resultado);})
    }

    useEffect(()=>
    {
        if(Mostrardo==ReferenciaDTO.UbicacionVendemosContigo)
        {
            traerGuias()
        }
    },[Mostrardo])


   const datos=(guia:any)=>
   {
    var i=0
    var identificador=-1 
    seleccionGuias.map((e:any)=>
    {

        if(e!=undefined)
        {
            if(e.guia==guia)
            {
                identificador=i
            }
        }
        i=i+1;

    })

    if(identificador>-1)
    {
        delete seleccionGuias[identificador]
    }else
    {
        SetseleccionGuias([...seleccionGuias,{guia}])
    }

     
   }

   const enviar=()=>
   {
        SetLoading(true)
        var guias:any=[]

        seleccionGuias.map((e:any)=>
        {
            if(e!=undefined)
            {
                guias.push(e)
            }
        })

        if(validador(guias))
        {
            var body=
            {
                nombre:state.Nombre,
                direccion:state.Direccion+" "+state.Numero +","+stateCaluladora.comuna,
                preparacion:state.preparacion,
                envio:state.envio,
                TotalGuias:guias,
                telefono:state.telefono,
                comuna:stateCaluladora.comuna
            }
            SetLoading(false)
            const dato3=Post2(VendemosContigo.ActualizarSin,JSON.stringify(body),"application/json",tok)
            dato3?.then(resultado=>{setguias([]);SetMensajeEmergente(resultado);SetLoading(false);traerGuias();SetId2(Id2+1)})
        }
        
   }

   const validador=(guias:any)=>
   {
        if(guias.length==0)
        {
            SetMensajeEmergente("Debe elegir las guias para despachar")
            SetLoading(false)
            return false
        }
        if(state.Nombre=="")
        {
            SetMensajeEmergente("Debe el nombre del destinatario")
            SetLoading(false)
            return false
        }
        if(state.Direccion=="")
        {
            SetMensajeEmergente("Debe ingresar la direccion de despacho")
            SetLoading(false)
            return false
        }

        if(state.preparacion=="")
        {
            SetMensajeEmergente("Debe especificar el tipo de preparacion")
            SetLoading(false)
            return false
        }
        if(state.envio=="")
        {
            SetMensajeEmergente("Debe especificar el envio")
            SetLoading(false)
            return false
        }
        return true
   }
   function cambio(event:any)
    {
      dispatch({type:"cambio",input:{
        name:event.target.name,
        value:event.target.value
      }})
      
    }

    return (
    <>
    <div>
        {guias.length==0?<>
        <p className="subtitulo" >Guias a Despachar</p>
        <div className="card">
                
                <div className="card-body" >
                
                    <p className="subtitulo" >No se encuentras guias para realizar PreAlertas</p>
                   
                </div>
                
            </div>
        
        
        </>:<>
        <p className="subtitulo" >Guias a Despachar</p>
            <div className="card">
                
                <div className="card-body" >
                <div className="col-md-12">
                <div className="col-12 py-2 py-sm-0">
                <div className="row"> 

                
                        
                    {guias!=""?<>{guias.map((row:any)=>
                            {
                                return(
                                <>
                                
                                <div className="col-sm-3 my-1 px-sm-2">
                                
                                <input type="checkbox" name="Precio" value={row.GUIAHIJA} defaultChecked={false} onClick={()=>{datos(row.GUIAHIJA)}}>
                                                        </input>
                                                        <strong style={{marginRight:"10px"}}> {row.GUIAHIJA} - {row.DESCRIPCION}</strong>
                                                                   
                                         </div>               
                                                                           
                                </>
                                )
                            })
                        
                        
                        
                        }</>:null}
</div>
                </div>
</div>

                </div>
                
            </div>
                
                                
        
        
        <div className="col-md-12">
            <div className="row">
                <div className="col-12 col-md-12" >
                    <p className="subtitulo" >Detalles</p>
                    <div className="card">
                
                        <div className="card-body" >
                            <div className="row g-3 needs-validation" >
                                
                                
                                <div className="col-6">
                
                                <label className="form-label">Direccion </label>
                                    <input name="Direccion" id="Direccion" value={state.Direccion} onChange={cambio} className="form-control" ></input>
                                    
                                    
                                </div>
                                <div className="col-6">
                
                                <label className="form-label">Numero</label>
                                    <input name="Numero" id="Numero" value={state.Numero} onChange={cambio} className="form-control" ></input>
                                    
                                </div>
                                <div className="col-6">
                                <label className="form-label">Region</label>
                                <select onChange={SelectCalDespacho} defaultValue={-1} className="col-12 col-m-8">
                                                    <option value="-1">----Seleccione Region----</option>
                                                    <option value="1">Región I</option>
                                                    <option value="2">Región II</option>
                                                    <option value="3">Región III</option>
                                                    <option value="4">Región IV</option>
                                                    <option value="5">Región V</option>
                                                    <option value="6">Región VI</option>
                                                    <option value="7">Región VII</option>
                                                    <option value="8">Región VIII</option>
                                                    <option value="9">Región IX</option>
                                                    <option value="10">Región X</option>
                                                    <option value="11">Región XI</option>
                                                    <option value="12">Región XII</option>
                                                    <option value="13">Región Metropolitana</option>
                                                    <option value="14">Región XIV</option>
                                                    <option value="15">Región XV</option>
                                                    <option value="16">Región XVI</option>
                                                      </select>
                                </div>
                                
                                <div className="col-6">
                                                    
                                                    <label className="form-label">Comuna</label>
                                                    <span id=""><select onChange={cambioComunaCal} className="col-12 col-m-8">
                                                    {SelectComunaCalculadora}
                                                    
                                                      </select></span> 
                                                </div>
                                <div className="col-6">
                
                                    <label className="form-label">Ciudad </label>
                                    <input name="Ciudad" id="Ciudad" value={state.Ciudad} onChange={cambio} className="form-control" ></input>
                                    
                                </div>
                                <div className="col-6">
                                    <label className="form-label">Nombre destinatario</label>
                                    <input name="Nombre" id="Nombre" value={state.Nombre} onChange={cambio} className="form-control" ></input>
                        
                                </div>
                                <div className="col-12">
                                    <label className="form-label">Especificacion de preparacion</label>
                                    <input name="preparacion" id="preparacion" value={state.preparacion} onChange={cambio} className="form-control" ></input>
                                    <p className="small py-1">caja, sobre, paquete</p>
                                </div>
                                <div className="col-12">
                                    <label className="form-label">Telefono destinatario</label>
                                    <input name="telefono" id="telefono" value={state.telefono} onChange={cambio} className="form-control" ></input>
                    
                                </div>
                                <div className="col-12">
                                    <label className="form-label">Especificacion de envio</label>
                                    <textarea name="envio" id="envio" value={state.envio} onChange={cambio} className="form-control" ></textarea>
                                    <p className="small py-1">2 poleras Xl rojas, 1 pantalon azul</p>
                                </div>
                                <div className="col-12">
                                    <input type="button" className="btn btn-success" id="enviarFactura" value="Subir solicitud de envio" onClick={()=>{enviar()}}/>
                                </div>
                    
                            </div>
                    
                        </div>
                
                                
                    </div>
                </div>
                            
            </div>
                
                        
        </div></>}
        
    </div>
    </>)
}